import { render, staticRenderFns } from "./RequestTable.vue?vue&type=template&id=9ada5d0c&scoped=true&"
import script from "./RequestTable.vue?vue&type=script&lang=ts&"
export * from "./RequestTable.vue?vue&type=script&lang=ts&"
import style0 from "./RequestTable.vue?vue&type=style&index=0&id=9ada5d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ada5d0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VDataTable,VIcon})
